import { useCallback } from "react"
import { environment, inLocalDevelopment } from "modules/environments"
import { authHostMap } from "services/hosts"
import { useFetch } from "utils/fetch"

const getHostNameForFetch = (path) => {
  if (inLocalDevelopment) return
  // All CAS API located at /api/auth/*
  return path.startsWith("/api/auth/") ? authHostMap[environment] : undefined
}

export const useGetData = (path) => {
  const { getData } = useFetch(getHostNameForFetch(path))
  return useCallback(
    (params, options) => getData(typeof path === "function" ? path(params) : path, params, options),
    [getData, path],
  )
}

export const usePostData = (path) => {
  const { postData } = useFetch(getHostNameForFetch(path))
  return useCallback(
    (data, options) => postData(typeof path === "function" ? path(data) : path, data, options),
    [postData, path],
  )
}
